import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { RetailClient } from 'src/WebApiController';

export function useGetBuyerPaymentMethods(
  buyerEmail: string | null | undefined
) {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();

  return useQuery({
    queryKey: [
      'getBuyerPaymentMethods',
      activeAccountWebClientConfig.activeAccountId,
      buyerEmail,
    ],
    queryFn: async () => {
      return await new RetailClient(
        activeAccountWebClientConfig
      ).getBuyerPaymentMethods(buyerEmail ?? undefined);
    },
    enabled:
      activeAccountWebClientConfig.activeAccountId != null && !!buyerEmail,
    refetchOnWindowFocus: false,
    meta: {
      onError: (error: ErrorTypes) => {
        showErrorDialog('RetailClient.getBuyerPaymentMethods', error);
      },
    },
  });
}
